export * from './env';
export * from './authentication';

export const channelTypes = [
  {
    label: 'Web',
    value: 'WEB'
  },
  {
    label: 'Android',
    value: 'ANDROID'
  },
  {
    label: 'iOS',
    value: 'IOS'
  }
];

export const DRAWER_WIDTH = 400;
export const SIDEBAR_WIDTH_MINIMIZED = 56;
export const HEADER_HEIGHT = 50; //SIDEBAR_WIDTH_MINIMIZED;
export const SIDEBAR_WIDTH = 240;
export const RIGHT_BOTTOM_BORDER = 4;
export * from './status';
